import * as PropTypes from "prop-types"
import styled, { css } from "styled-components"
import { useLocale } from "react-polyglot-hooks"
import { ButtonContainer } from "components/forms/CallMeForm"
import {useContext, useRef, useState} from "react"
import { CarContext } from "scenes/CarScene/CarContext"
import { color, mq } from "helpers/styled"
import { FormContext, states } from "scenes/CarScene/Form"
import { useRouter } from "next/router"
import dynamic from "next/dynamic"
import CarData from "./CarData"

const CRif = dynamic(() => import("./CRif"))
const Whatsapp = dynamic(() => import("./Whatsapp"))
const Form = dynamic(() => import("./Form"))
const Loading = dynamic(() => import("./Loading"))
const Completed = dynamic(() => import("./Completed"))

const Background = styled.div`
  background: ${color("paleGray")};
  color: white;
  padding-top: 40px;
  padding-bottom: 40px;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    pointer-events: none;
    touch-action: none;
    background-color: ${color("darkBlue")}cc;
    transition: opacity 0.2s;
    opacity: 0;
  }

  ${({ load }) =>
    load
      ? css`
          &:before {
            z-index: 99;
            opacity: 1;
            pointer-events: all;
            touch-action: auto;
          }

          > ${Container} {
            position: relative;
            z-index: 100;
          }
        `
      : null}
`

const Container = styled.div`
  width: 100%;
  max-width: 375px;
  padding: 10px 10px 0;
  margin: 0 auto;
  background: ${color("darkBlue")};
  border-radius: 16px;
  box-shadow: 0 2px 16px 0 rgba(2, 24, 89, 0.4);

  @media ${mq("lg")} {
    max-width: 500px;
    padding: 35px 35px 25px;
  }

  @media ${mq("xl")} {
    max-width: 525px;
    padding: 50px 35px 25px;
  }
`

const Body = styled.div`
  padding: 25px 15px 0;

  > :last-child {
    max-width: none;

    /* TODO: Fix hardcoded margin on all inputs */
    [style="margin-bottom: 15px;"] {
      margin-bottom: 10px !important;
    }

    ${ButtonContainer} {
      padding-top: 10px;

      @media ${mq("lg")} {
        padding-top: 25px;
      }

      button {
        margin-top: 10px;
        width: 100%;
      }
    }
  }
`

export default function PlanForm({ car, selectedPlan, page, initialData }) {
  const { sold } = car
  const { formRef } = useContext(CarContext)
  const { state, setState } = useContext(FormContext)
  const locale = useLocale()
  const { push } = useRouter()

  const ref = useRef(null)
  const containerRef = useRef(null)
  const [leadData, setLeadData] = useState({})

  const goToOnline = leasingId => {
    setState(states.FCA)
    push(`/${locale}/online/${leasingId}/empezar`)
  }

  const isLoading = [states.LOADING, states.FCA, states.WHATSAPP, states.CRIF].includes(state)

  return (
    <div>
      <Background ref={ref} load={isLoading}>
        <Container ref={containerRef}>
          {!sold && <CarData car={car} selectedPlan={selectedPlan} />}
          <Body ref={formRef}>
            {(() => {
              switch (state) {
                case states.FORM:
                case states.LOADING:
                default:
                  return <Form {...{ car, page, initialData, selectedPlan, setLeadData, setState, goToOnline }} />
                case states.WHATSAPP:
                  return <Whatsapp {...{ leadData, page, setState, goToOnline }} />
                case states.CRIF:
                  return <CRif {...{ leadData, page, setState, goToOnline }} />
                case states.DONE:
                  return <Completed {...{ leadData, car, page, setState, goToOnline }} />
                case states.FCA:
                  return <Loading />
              }
            })()}
          </Body>
        </Container>
      </Background>
    </div>
  )
}

PlanForm.defaultProps = {
  initialData: {}
}

PlanForm.propTypes = {
  page: PropTypes.string.isRequired,
  car: PropTypes.object.isRequired,
  selectedPlan: PropTypes.object.isRequired,
  initialData: PropTypes.object
}
